const DB_NAME = 'teslaSelfie'
const STORE_NAME = 'selfieCache'
const VERSION = 1

function openDB() {
  return new Promise((resolve, reject) => {
    const req = window.indexedDB.open(DB_NAME, VERSION)
    req.onupgradeneeded = e => {
      const db = e.target.result
      if (!db.objectStoreNames.contains(STORE_NAME)) db.createObjectStore(STORE_NAME)
    }
    req.onsuccess = e => resolve(e.target.result)
    req.onerror = e => reject(e.target.error || new Error('indexeddb_open_error'))
  })
}

function getItem(key) {
  return openDB()
    .then(db => new Promise((resolve, reject) => {
      const tx = db.transaction(STORE_NAME, 'readonly')
      const store = tx.objectStore(STORE_NAME)
      const req = store.get(key)
      req.onsuccess = () => resolve(req.result)
      req.onerror = () => reject(req.error || new Error('indexeddb_get_error'))
    }))
    .catch(() => {
      try {
        const v = localStorage.getItem(key)
        return v ? JSON.parse(v) : null
      } catch {
        return null
      }
    })
}

function setItem(key, value) {
  return openDB()
    .then(db => new Promise((resolve, reject) => {
      const tx = db.transaction(STORE_NAME, 'readwrite')
      const store = tx.objectStore(STORE_NAME)
      const req = store.put(value, key)
      req.onsuccess = () => resolve(true)
      req.onerror = () => reject(req.error || new Error('indexeddb_set_error'))
    }))
    .catch(() => {
      try {
        localStorage.setItem(key, JSON.stringify(value))
        return true
      } catch {
        return false
      }
    })
}

function increment(key, by = 1) {
  return getItem(key).then(curr => {
    const next = (parseInt(curr || 0, 10) || 0) + by
    return setItem(key, next).then(() => next)
  })
}

export default { getItem, setItem, increment }

